import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header";

const getLineOfBusiness = () => {
  return axios.get(API + "company/lobs/", { headers: authHeader() });
};

const createLineOfBusiness = (data) => {
  return axios.post(API + "company/lobs/create/", data, {
    headers: authHeader(),
  });
};

const updateLineOfBusiness = (id, data) => {
  return axios.put(API + `company/lobs/${id}/update/`, data, {
    headers: authHeader(),
  });
};

const deleteLineOfBusiness = (id) => {
  return axios.delete(API + `company/lobs/${id}/delete/`, {
    headers: authHeader(),
  });
};

const lineOfBusinessService = {
  getLineOfBusiness,
  createLineOfBusiness,
  updateLineOfBusiness,
  deleteLineOfBusiness,
};

export default lineOfBusinessService;
